import PostbackActions from '../../../../actions/PostbackActions';
import CustomNotify from '../../../Notify';
import UserStore from '../../../../stores/UserStore';

const sanitizeParameters = (params = []) => {
    const seen = new Set();
    return Array.isArray(params)
        ? params.filter((item = {}) => {
            const name = item?.name;
            const value = item?.value;
            if (!name || !value) return false;
            const key = `${name}:::${value}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        })
        : [];
};

export const actions = {
    onSave(state) {
        const normalizedParameters = sanitizeParameters(state.queryParams);

        let params = {
            title: state.title,
            url: state.url,
            method: state.method,
            currency: state.currency,
            locale: state.locale,
            conversion_statuses: state.conversionStatuses.join(','),
            goal_action_ids: state.goalActionIds.join(','),
            parameters: JSON.stringify(normalizedParameters),
            track_parameter: JSON.stringify(state.trackParameter),
            success_string: state.successString
        };

        if (!state.trackParameter.name || !state.trackParameter.value) {
            params.unset_track_parameter = '1';
            delete params.track_parameter;
        }

        const shouldUnsetParameters = !normalizedParameters.length;

        if (shouldUnsetParameters) {
            params.unset_parameters = '1';
            delete params.parameters;
        } else {
            delete params.unset_parameters;
        }

        if (state.edit) {
            params.id = state.id;
            params.unset_conversion_statuses = !state.conversionStatuses.length ? '1' : '';
            params.unset_goal_action_ids = !state.goalActionIds.length ? '1' : '';

            if (!state.successString) {
                params.unset_success_string = '1';
                delete params.success_string;
            }

            PostbackActions.editPostback(params, () => {
                actions.onSuccessSave();
                if (state.id) {
                    PostbackActions.getListPostbacks({ ids: state.id });
                }
            });
        } else {

            PostbackActions.savePostback(params, (response) => {
                actions.onSuccessSave(response.id);
            });
        }
    },

    onSuccessSave(newCreateId) {
        const staticNames = UserStore.getTranslation().postbackPage.creatingEditing;

        if (!newCreateId) {
            CustomNotify(staticNames.successEdit || 'Postback changed successfully', 'success');
        } else {
            CustomNotify(staticNames.successCreate || 'Postback successfully created', 'success');
        }

    },

    clearErrors() {
        PostbackActions.clearErrors();
    },

    onDelete(id, callback) {
        PostbackActions.deletePostback({ id }, callback);
    }
};
